// /src/firestore.js
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyA3qkaxkHnh-CiTjjK5IcbwjFGGxW2El9o",
  authDomain: "africanring.firebaseapp.com",
  projectId: "africanring",
  storageBucket: "africanring.appspot.com",
  messagingSenderId: "144494149866",
  appId: "1:144494149866:web:12e86eeeaa92be022f5793",
};

const firestore = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export default db;